import HeaderComponent from "../../components/HeaderComponent";
import SidebarComponent from "../../components/SidebarComponent";
import ConfirmationSummary from "./components/confirmationSummary"

function ReviewBookingAndConfirm () {



    return (
        <>
            <SidebarComponent activeMenu={['sidemenu-list active', 'sidemenu-list', 'sidemenu-list']}/>
            <HeaderComponent></HeaderComponent>
            <ConfirmationSummary/>
        </>
    )
}

export default ReviewBookingAndConfirm;